import Plyr from 'plyr';

/**
 * Initializes the project case-study modal and the embedded Plyr video player.
 * Returns { openModal } so other modules can trigger it.
 */
export function initModal() {
  const modal = document.getElementById('project-modal');
  const modalTitle = document.getElementById('modal-title');
  const modalSub = document.getElementById('modal-sub');
  const modalContext = document.getElementById('modal-context');
  const modalTech = document.getElementById('modal-tech');
  const modalClose = document.querySelector('.modal-close');
  const modalVideoContainer = document.querySelector('.modal-video-container');
  const modalLink = document.getElementById('modal-external-link');
  const modalLinkText = document.getElementById('modal-external-text');

  // Create modal spinner
  const modalSpinner = document.createElement('div');
  modalSpinner.className = 'video-spinner hidden';
  modalVideoContainer.appendChild(modalSpinner);

  // Initialize Plyr
  const player = new Plyr('#modal-video', {
    controls: [
      'play-large',
      'rewind',
      'play',
      'fast-forward',
      'progress',
      'current-time',
      'mute',
      'volume',
      'fullscreen',
    ],
    seekTime: 10,
  });

  // Hide spinner when video is ready
  player.on('canplay', () => modalSpinner.classList.add('hidden'));
  player.on('playing', () => modalSpinner.classList.add('hidden'));

  // Pause video if external link is clicked
  if (modalLink) {
    modalLink.addEventListener('click', () => {
      player.pause();
    });
  }

  function openModal(data) {
    if (!data) return;

    modalTitle.textContent = data.title || 'Featured Cut';
    modalSub.textContent = data.sub || 'Video Editing Portfolio';
    modalContext.textContent =
      data.context ||
      'A groundbreaking project utilizing premium visual pacing, dynamic masking, and theater-level color grading to captivate audiences and dramatically improve viewer retention across all targeted demographics.';

    // Tech pills
    modalTech.innerHTML = '';
    const techArray = data.tech || ['Premiere Pro', 'After Effects', 'Davinci Resolve', 'Sound Design'];
    techArray.forEach((t) => {
      const span = document.createElement('span');
      span.className = 'pill';
      span.textContent = t;
      modalTech.appendChild(span);
    });

    // Show spinner while new source loads
    modalSpinner.classList.remove('hidden');

    // External Link Logic
    if (modalLink && data.url) {
      modalLink.href = data.url;
      modalLink.classList.remove('hidden');
      
      // Reset custom styles
      modalLink.classList.remove('youtube-style', 'reels-style');
      
      // Determine the platform text and style
      let platformName = data.urlPlatform || ''; 
      
      if (!platformName) {
        if (data.url.includes('youtube.com') || data.url.includes('youtu.be')) {
          platformName = 'YouTube';
          modalLink.classList.add('youtube-style');
        } else if (data.url.includes('tiktok.com')) {
          platformName = 'TikTok';
          modalLink.classList.add('reels-style');
        } else if (data.url.includes('instagram.com')) {
          platformName = 'Instagram';
          modalLink.classList.add('reels-style');
        } else {
          platformName = 'Website';
        }
      } else {
        // If they provided a custom platform name, we can still try to apply styles
        // based on the name if it matches known brands.
        const lowerName = platformName.toLowerCase();
        if (lowerName === 'youtube') modalLink.classList.add('youtube-style');
        if (lowerName === 'tiktok' || lowerName === 'instagram') modalLink.classList.add('reels-style');
      }

      modalLinkText.textContent = `View on ${platformName}`;
      
    } else {
      // Hides the button entirely if there is no URL
      modalLink.classList.add('hidden');
      modalLink.classList.remove('youtube-style', 'reels-style');
      modalLink.href = '#';
    }

    // Set video source — use HD modalSrc when available, fallback to preview src
    const videoUrl = data.modalSrc || data.src;
    player.source = {
      type: 'video',
      sources: [
        {
          src: videoUrl,
          type: videoUrl.endsWith('.webm') ? 'video/webm' : 'video/mp4',
        },
      ],
    };

    if (data.format === 'vertical') {
      modal.classList.add('vertical-layout');
    } else {
      modal.classList.remove('vertical-layout');
    }

    modal.classList.add('modal-active');
    player.play().catch(() => {});
  }

  function closeModal() {
    modal.classList.remove('modal-active');
    setTimeout(() => {
      player.pause();
    }, 500);
  }

  modalClose.addEventListener('click', closeModal);

  // Hide custom cursor when hovering modal
  modal.addEventListener('mouseenter', () => {
    const cursor = document.querySelector('.custom-cursor');
    if (cursor) cursor.style.opacity = '0';
  });
  modal.addEventListener('mouseleave', () => {
    const cursor = document.querySelector('.custom-cursor');
    if (cursor) cursor.style.opacity = '1';
  });

  return { openModal };
}
